import WithRender from "../templates/base/app.html";
import Vue from "vue";
import VueHead from "vue-head";
import { mapActions, mapGetters } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { getLayoutName, getMyAccountLayoutName } from "../layouts.js";

// version 0.3.8
Vue.use(VueHead);

export default WithRender({
  components: {
    appLayoutImageEditor: function () {
      return import(
        /* webpackChunkName: "lfp" */ "../external_components/components/LayoutImageEditor.js"
      );
    }
  },
  name: "App",
  computed: {
    ...mapGetters([
      "getIsLoading",
      "getLayoutType",
      "getShowChangeOptionsLoader",
      "getPersonalizeLoading",
      "getNetworkError",
      "getIsMyAccount",
      "getSelector",
      "getSelectionId",
      "getPreview3DLoading",
      "getMatrixConfiguration",
      "getIsCimpressDefaultSelection",
      "getIsCimpressPreferredSelection"
    ]),
    getPortalElements: function () {
      return this.portalElements;
    },
    getLayout: function () {
      if (this.getIsCimpressDefaultSelection) {
        return getLayoutName("cimpressDefaultSelection");
      }
      if (this.getIsCimpressPreferredSelection) {
        return getLayoutName("cimpressPreferredSelection");
      }
      if (this.getIsMyAccount) {
        return getMyAccountLayoutName();
      }
      return getLayoutName(this.getLayoutType);
    }
  },

  methods: {
    ...mapActions([
      "setIsLoading",
      "loadInitialData",
      "setIsMobile",
      "setMainWindow",
      "onScrollEvent"
    ]),
    handleScroll(event) {
      this.onScrollEvent(event);
    }
  },
  data: function () {
    return {
      vers: process.env.VUE_APP_VERSION,
      isMobileClass: window.innerWidth <= 990 ? "matrix_layoutMainMobile" : ""
    };
  },
  created() {
    window.printqMatrixVersion = process.env.VUE_APP_VERSION;
    window.globalStore = this.$store;

    this.setIsMobile(window.innerWidth <= 990);

    if (!String.prototype.rtrim) {
      String.prototype.rtrim = function (s) {
        if (s == undefined) s = "\\s";
        return this.replace(new RegExp("[" + s + "]*$"), "");
      };
    }

    if (!String.prototype.ltrim) {
      String.prototype.ltrim = function (s) {
        if (s == undefined) s = "\\s";
        return this.replace(new RegExp("^[" + s + "]*"), "");
      };
    }

    if (!String.prototype.replaceAll) {
      String.prototype.replaceAll = function (search, replacement) {
        var target = this;
        return target.split(search).join(replacement);
      };
    }
    if (!String.prototype.insert) {
      String.prototype.insert = function (index, string) {
        if (index > 0)
          return (
            this.substring(0, index) +
            string +
            this.substring(index, this.length)
          );
        else return string + this;
      };
    }

    addEventListener("resize", () => {
      this.setIsMobile(window.innerWidth <= 990);
      this.isMobileClass =
        window.innerWidth <= 990 ? "matrix_layoutMainMobile" : "";
    });

    window.addEventListener("scroll", this.handleScroll);

    this.setIsLoading(true);
    this.setMainWindow(this);
    this.loadInitialData({
      webProductId: this.webProductId,
      webProductSku: this.webProductSku,
      customer: this.customer || uuidv4(),
      selectionId: this.selectionId,
      initialConfig: this.initialConfig,
      getConfigTokenData: this.getConfigTokenData,
      base_url: this.base_url,
      urls: this.urls,
      beforeChangeOptionsCallback:
        this.beforeChangeOptionsCallback &&
        typeof this.beforeChangeOptionsCallback == "function"
          ? this.beforeChangeOptionsCallback
          : null,
      afterChangeOptionsCallback:
        this.afterChangeOptionsCallback &&
        typeof this.afterChangeOptionsCallback == "function"
          ? this.afterChangeOptionsCallback
          : null,
      afterChangePageOptionCallback:
        this.afterChangePageOptionCallback &&
        typeof this.afterChangePageOptionCallback == "function"
          ? this.afterChangePageOptionCallback
          : null,
      onCartSubmitCallback:
        this.onCartSubmitCallback &&
        typeof this.onCartSubmitCallback == "function"
          ? this.onCartSubmitCallback
          : _ => _,
      beforePersonalizeCallback:
        this.beforePersonalizeCallback &&
        typeof this.beforePersonalizeCallback == "function"
          ? this.beforePersonalizeCallback
          : null,
      photoMappingCallback:
        this.photoMappingCallback &&
        typeof this.photoMappingCallback == "function"
          ? this.photoMappingCallback
          : null,

      initFinalizeCallback:
        this.initFinalizeCallback &&
        typeof this.initFinalizeCallback == "function"
          ? this.initFinalizeCallback
          : null,

      isMyAccount: this.isMyAccount,
      myAccountSelection: this.myAccountSelection,
      myAccountUploadPath: this.myAccountUploadPath,
      myAccountUploadedFiles: this.myAccountUploadedFiles,
      theme: this.theme,
      toggleReadyToConnect:
        this.toggleReadyToConnect &&
        typeof this.toggleReadyToConnect == "function"
          ? this.toggleReadyToConnect
          : null,
      selector: this.selector,
      config: this.config
    });
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  props: [
    "webProductId",
    "webProductSku",
    "customer",
    "portalElements",
    "selectionId",
    "initialConfig",
    "urls",
    "beforeChangeOptionsCallback",
    "afterChangeOptionsCallback",
    "afterChangePageOptionCallback",
    "onCartSubmitCallback",
    "beforePersonalizeCallback",
    "photoMappingCallback",
    "isMyAccount",
    "myAccountSelection",
    "myAccountUploadedFiles",
    "toggleReadyToConnect",
    "myAccountUploadPath",
    "selector",
    "getConfigTokenData",
    "theme",
    "config",
    "initFinalizeCallback"
  ]
});
